import { tns } from 'tiny-slider';

export function doelgroepenSlider() {
    let slider = document.getElementById('doelgroepen-slider');
    if (slider) {
        slider = tns({
            container: '#doelgroepen-slider',
            items: 1.25,
            gutter: 16,
            autoplay: true,
            autoplaySpeed: 1500,
            autoplayTimeout: 4000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: false,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                576: {
                    items: 1.75
                },
                768: {
                    items: 2.25,
                    gutter: 32,
                },
                1024: {
                    items: 3,
                    gutter: 48,
                },
                1320: {
                    gutter: 80,
                }
            }
        });
    }
    return 'doelgroepenSlider';
}



export function tevredenheidsonderzoekSlider() {
    let slider = document.getElementById('tevredenheidsonderzoek-slider');
    if (slider) {
        slider = tns({
            container: '#tevredenheidsonderzoek-slider',
            items: 1,
            gutter: 16,
            autoplay: false,
            autoplaySpeed: 1500,
            loop: false,
            autoHeight: true,
            autoplayTimeout: 4000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: false,
            mouseDrag: false,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: false,
        });
        let nextButton = document.querySelector('.js-tns-next');
        let prevButton = document.querySelector('.js-tns-prev');
        nextButton.addEventListener('click', function () {
            slider.goTo('next');
        });
        prevButton.addEventListener('click', function () {
            slider.goTo('prev');
        });
    }
    return 'tevredenheidsonderzoekSlider';
}
